// extracted by mini-css-extract-plugin
export var sbShowMain = "item-module--sb-show-main--3KxQu";
export var item = "item-module--item--be2JU";
export var label = "item-module--label--1haPw";
export var inner = "item-module--inner--6flex";
export var title = "item-module--title--3aK0E";
export var text = "item-module--text--2vuTD";
export var flexGrow = "item-module--flexGrow--3f27M";
export var image = "item-module--image--2NdE6";
export var eventImage = "item-module--eventImage--QqHQ2";
export var eventLocationWrapper = "item-module--eventLocationWrapper--2P3AF";